import _Event from "@mui/icons-material/Event";
var _templateObject;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import NavBarItem from 'app/components/navBar/NavBarItem';
import styled from 'styled-components';
import { styled as muiStyled } from '@mui/material/styles';
import { COLORS } from '@fupa/fupa-uikit';
import { Badge } from '@mui/material';
import useShowLiveBadge from 'app/components/navBar/useShowLiveBadge';
const StyledBadge = muiStyled(Badge)(() => ({
  '& .MuiBadge-badge': {
    right: '-10px',
    border: "1px solid ".concat(COLORS.lightestGrey),
    padding: '0 4px'
  }
}));
const StyledEvent = styled(_Event).withConfig({
  componentId: "sc-1f32ym3-0"
})(["&&&{color:", ";font-size:20;", "}"], props => props.selected ? COLORS.fupaSecondary : COLORS.darkerGrey, props => props.theme.desktopLayout(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      color: ", ";\n      padding-bottom: 0.75rem;\n    "])), props.selected ? COLORS.fupaSecondary : COLORS.lighterGrey));
export default function NavBarItemMatches(_ref) {
  let {
    isSelected,
    districtSlug,
    ...props
  } = _ref;
  const showLiveBadge = useShowLiveBadge(districtSlug);
  return /*#__PURE__*/React.createElement(NavBarItem, _extends({
    isSelected: isSelected,
    follow: true,
    label: "Spiele"
  }, props, {
    "data-sentry-element": "NavBarItem",
    "data-sentry-component": "NavBarItemMatches",
    "data-sentry-source-file": "NavBarItemMatches.tsx"
  }), /*#__PURE__*/React.createElement(StyledBadge, {
    badgeContent: 'live',
    color: "secondary",
    invisible: !showLiveBadge,
    "data-sentry-element": "StyledBadge",
    "data-sentry-source-file": "NavBarItemMatches.tsx"
  }, /*#__PURE__*/React.createElement(StyledEvent, {
    selected: isSelected,
    "data-sentry-element": "StyledEvent",
    "data-sentry-source-file": "NavBarItemMatches.tsx"
  })));
}